import { Paper } from '@mui/material';
import bankStyles from '../../assets/css/banks.module.css';
import { PulseLoader } from 'react-spinners';
import { RefObject } from 'react';
import { selectPrimaryColor } from '../../app/slices/configuration.slice';
import { useTranslation } from 'react-i18next';
import { LOAD_MORE_PAGINATION_PREFIX } from '../../utils/translationPagePrefix';
import { useAppSelector } from '../../app/hooks';

interface PaginationProps {
	hasNext: boolean;
	isLoadingMore: boolean;
	isEmpty?: boolean;
	searchRef?: RefObject<HTMLInputElement>;
	setSize(size: number | ((prevSize: number) => number)): void;
}

const LoadMorePagination = ({ setSize, hasNext, isLoadingMore, isEmpty = false, searchRef }: PaginationProps) => {
	const { t } = useTranslation();

	const primaryColor = useAppSelector(selectPrimaryColor);
	const isEmptyTitle = t(`${LOAD_MORE_PAGINATION_PREFIX}.is-empty-title`);
	if (isEmpty) {
		return (
			<div className={bankStyles['no-results-text-container']}>
				<span className={bankStyles['no-results-text']}>{isEmptyTitle}</span>
			</div>
		);
	}

	const hasNextTitle = t(`${LOAD_MORE_PAGINATION_PREFIX}.has-next-title`);
	const inlineStyles = {
		fontSize: '18px',
		color: primaryColor,
		cursor: 'pointer',
		fontWeight: '300'
	};
	if (!hasNext) {
		return (
			<span
				style={inlineStyles}
				onClick={() => {
					if (searchRef && searchRef.current) {
						searchRef.current.focus();
					}
				}}
			>
				{hasNextTitle}
			</span>
		);
	}

	const showMoreText = t(`${LOAD_MORE_PAGINATION_PREFIX}.show-more`);
	return (
		<Paper
			elevation={1}
			className={bankStyles['show-more-button']}
			onClick={!isLoadingMore ? () => setSize((prevSize) => prevSize + 1) : undefined}
		>
			{isLoadingMore ? <PulseLoader size="5" /> : <span id="show-more-button">{showMoreText}</span>}
		</Paper>
	);
};

export default LoadMorePagination;
